// Session expiry, as a one-line broadcast.
//
// Sessions die on their own schedule: the cookie outlives nothing in
// particular, and the first the browser hears of it is a 401 on whatever
// the user was doing. The REST client fires `onUnauthorized` for every
// 401 it sees (queries and mutations alike), and this is where that
// lands so a single listener can tell the user what happened.
//
// It is deliberately not React state: a 401 can arrive from a background
// refetch while nothing relevant is mounted, and it must not depend on a
// provider being in the tree at that moment.

type Listener = () => void;

const listeners = new Set<Listener>();

/** Called by the API client on every 401. */
export function notifySessionExpired(): void {
  for (const listener of [...listeners]) listener();
}

/** Subscribe to session expiry; returns the unsubscribe function. */
export function onSessionExpired(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
